module.exports = __webpack_public_path__ + "img/paiement-big-icon.8dd1fcf8.svg";